module.exports = [
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "حنفية المطبخ GROHE RED Duo (صنبور على شكل حرف \\'\\'C\\'\\') المزودة بطقم مصفاة وسخان بحجم L لغلي المياه في الحال. مطلية بالكروم. حاصلة على تقييم A في كفاءة الطاقة وميزات الأمان",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and L size boiler",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "حنفية المطبخ GROHE RED Mono (صنبور على شكل حرف C) المزوَّدة بمجموعة مصافٍ وسخان حجم L لتوفير مياه مغلية فورية. مطلية بالكروم. حاصلة على تقييم A في كفاءة الطاقة وميزات الأمان",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "حنفية المطبخ GROHE RED Duo (صنبور على شكل حرف L) المزوَّدة بمجموعة مصافٍ وسخان حجم L لتوفير مياه مغلية فورية. طبقة بمظهر إستانلس إستيل غير لامع. حاصلة على تقييم A في كفاءة الطاقة وميزات الأمان",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "حنفية المطبخ GROHE RED Duo (صنبور على شكل حرف L) المزوَّدة بمجموعة مصافٍ وسخان حجم M لتوفير مياه مغلية فورية. مطلية بالك��وم. حاصلة على تقييم A في كفاءة الطاقة وميزات الأمان",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "حنفية المطبخ GROHE RED Duo (صنبور على شكل حرف L) المزوَّدة بمجموعة مصافٍ وسخان حجم M لتوفير مياه مغلية فورية. مظهر إستانلس إستيل غير لامع. حاصلة على تقييم A في كفاءة الطاقة وميزات الأمان",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout Starter kit",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "طقم تشغيل GROHE Blue Home Duo: خلاط مطبخ مزود بمقبض فردي يوفر لكِ المياه المُصفاة والمُبردة والفوّارة. ويشمل الطقم أيضًا وحدة مبرّد، ومصفاة وزجاجة لإشباع السائل بثاني أكسيد الكربون. صنبور عالٍ على شكل حرف \"L\" مطلي بالكروم.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "حنفية المطبخ GROHE RED Duo (صنبور على شكل حرف C) المزوّدة بمجموعة مصافٍ وسخان حجم M لتوفير مياه مغلية فورية. مطلية بالكروم. حاصلة على تقييم A في كفاءة الطاقة وميزات الأمان",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "حنفية المطبخ GROHE RED Duo (صنبور على شكل حرف L) المزوَّدة بمجموعة مصافٍ وسخان حجم L لتوفير مياه مغلية فورية. مطلية بالكروم. حاصلة على تقييم A في كفاءة الطاقة وميزات الأمان",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "&#160;عدّة البدء Mono<br />",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "طقم تشغيل GROHE Blue Home Duo: حنفيّة عمودية توفر لكِ المياه المصفاة والمُبردة والفوّارة. ويشمل الطقم أيضًا وحدة مبرّد، ومصفاة وزجاجة لإشباع السائل بثاني أكسيد الكربون. صنبور عال على شكل حرف \"C\" مطلي بالكروم.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout Starter kit",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "طقم تشغيل GROHE Blue Home Duo: خلاط مطبخ مزود بمقبض فردي يوفر لكِ المياه المُصفاة والمُبردة والفوّارة. ويشمل الطقم أيضًا وحدة مبرّد، ومصفاة وزجاجة لإشباع السائل بثاني أكسيد الكربون. صنبور عال على شكل حرف \"L\" يتميز بمظهر إستانلس إستيل.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "حنفية المطبخ GROHE RED Mono (صنبور على شكل حرف C) المزوَّدة بمجموعة مصافٍ وسخان حجم M لتوفير مياه مغلية فورية. مطلية بالكروم. حاصلة على تقييم A في كفاءة الطاقة وميزات الأمان",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout Starter kit",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "طقم تشغيل GROHE Blue Home Duo: خلاط مطبخ مزود بمقبض فردي يوفر لكِ المياه المُصفاة والمُبردة والفوّارة. ويشمل الطقم أيضًا وحدة مبرّد، ومصفاة وزجاجة لإشباع السائل بثاني أكسيد الكربون. صنبور عال على شكل حرف \"C\" مطلي بالكروم.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout Starter kit",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "طقم تشغيل GROHE Blue Home Duo: خلاط مطبخ مزود بمقبض فردي يوفر لكِ المياه المُصفاة والمُبردة والفوّارة. ويشمل الطقم أيضًا وحدة مبرّد، ومصفاة وزجاجة لإشباع السائل بثاني أكسيد الكربون. صنبور عالٍ على شكل حرف \"C\" يتميز بمظهر إستانلس إستيل.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout Starter kit",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "طقم تشغيل GROHE Blue Home Duo: خلاط مطبخ مزود بمقبض فردي يوفر لكِ المياه المُصفاة والمُبردة والفوّارة. ويشمل الطقم أيضًا وحدة مبرّد، ومصفاة وزجاجة لإشباع السائل بثاني أكسيد الكربون. صنبور عال على شكل حرف \"U\" مطلي بالكروم.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout Starter kit",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "طقم تشغيل GROHE Blue Home Duo: خلاط مطبخ مزود بمقبض فردي يوفر لكِ المياه المُصفاة والمُبردة والفوّارة. ويشمل الطقم أيضًا وحدة مبرّد، ومصفاة وزجاجة لإشباع السائل بثاني أكسيد الكربون. صنبور عالٍ على شكل حرف \"U\" يتميز بمظهر إستانلس إستيل.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30339001",
		"textblock_2nd_text": "حنفية مطبخ من GROHE RED Mono (صباب على شكل حرف L) مع مجموعة المصفاة وسخان بحجم متوسط لتوفير مياه مغلية فورية. مطلية بالكروم. حاصلة على تقييم A في كفاءة الطاقة وميزات الأمان",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "حنفية المطبخ GROHE RED Duo (صنبور على شكل حرف C) المزوّدة بمجموعة مصافٍ وسخان حجم M لتوفير مياه مغلية فورية. مظهر الفولاذ المقاوم للصدأ غير لامع. حاصلة على تقييم A في كفاءة الطاقة وميزات الأمان",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "حنفية المطبخ GROHE RED Duo (صنبور على شكل حرف \\'\\'C\\'\\') المزودة بطقم مصفاة وسخان بحجم كبير لتوفير مياه مغلية فورية. مظهر الفولاذ المقاوم للصدأ غير لامع. حاصلة على تقييم A في كفاءة الطاقة وميزات الأمان",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/ar_sa/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_ar_sa.json
// module id = 870
// module chunks = 0